export default __webpack_public_path__ + "media/images/backgrounds/bg-1-3c19f8b6d7b0a0cc3ecf8a7dd84c9381.jpg";